export const todayIso = (d = new Date()): string => {
  // Yerel gün — toISOString() UTC'ye çevirip gün kaydırabilir, o yüzden elle kuruyoruz.
  const p = (n: number) => String(n).padStart(2, '0')
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`
}

export const fmt = (n: number, digits = 1): string =>
  n.toLocaleString('tr-TR', { minimumFractionDigits: digits, maximumFractionDigits: digits })

export const fmtInt = (n: number): string => Math.round(n).toLocaleString('tr-TR')

export const trDate = (iso: string): string => {
  const [y, m, d] = iso.split('-')
  return `${d}.${m}.${y}`
}

export const clock = (totalSeconds: number): string => {
  const s = Math.max(0, totalSeconds)
  return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`
}
